import { render, staticRenderFns } from "./InsLayer.vue?vue&type=template&id=e04b0fba&scoped=true&"
import script from "./InsLayer.vue?vue&type=script&lang=ts&"
export * from "./InsLayer.vue?vue&type=script&lang=ts&"
import style0 from "./InsLayer.vue?vue&type=style&index=0&lang=less&"
import style1 from "./InsLayer.vue?vue&type=style&index=1&id=e04b0fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04b0fba",
  null
  
)

export default component.exports